import React, { Component } from 'react'
import RouteManager from '../../managers/RouteManager';
import NotificationPopup from './NotificationPopup';

export default class Notifications extends Component {
    componentDidMount() {
        RouteManager.setPresenter(this);
    }

    render() {
        return (
            <div id="notification-section" className="row justify-content-center">
                <div className="bg-white pl-m pr-m pb-xl pt-s border-radius-s shadow-m border-m"
                    style={{ width: '500px' }}
                >
                    <NotificationPopup />
                </div>
            </div>
        )
    }
}
